import Vue from 'vue'
import App from './App.vue'
import store from './store'
import vuetify from './plugins/vuetify';
// eslint-disable-next-line
import styles from './scss/_main.scss';
import router from "./router";
import i18n from './plugins/i18n';
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format';

import AWSAppSyncClient from "aws-appsync"
import VueApollo from 'vue-apollo'
import appSyncConfig from './AppSync'
import auth from './cognito-auth/cognitoAuth';

const config = {
  url: appSyncConfig.graphqlEndpoint,
  region: appSyncConfig.region,
  auth: {
    type: appSyncConfig.authenticationType,
    jwtToken: async () => auth.auth.getSignInUserSession().getIdToken().jwtToken
  }
}
const options = {
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
    }
  }
}

const client = new AWSAppSyncClient(config, options)
const appsyncProvider = new VueApollo({
  defaultClient: client
});

Vue.config.productionTip = false
Vue.use(VueFilterDateFormat);
Vue.use(VueApollo);

new Vue({
  vuetify,
  i18n,
  store,
  router,
  provide: appsyncProvider.provide(),
  render: h => h(App)
}).$mount('#app')